export default "__VITE_ASSET__91350306__"